<template>
  <div style="width: 100%" class="pa-2">
    <div class="btn-group justify-between align-center">
      <span class="ml-2">Thư mục</span>
      <v-spacer></v-spacer>
      <v-btn icon small tile color="error" @click.stop="deleteFont(item.id)">
        <v-icon>mdi-delete-outline</v-icon>
      </v-btn>
    </div>
    <v-divider class="mx-1"></v-divider>
    <div class="d-flex justify-start">
      <v-avatar color="#F4F7FA" size="80" class="mb-1 mt-4">
        <v-icon size="50"> mdi-format-font</v-icon>
      </v-avatar>
      <div class="pl-4 pt-3">
        <div style="font-size: 18px">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, require: true, default: () => ({}) },
  },
  data: () => ({}),
  computed: {
    item() {
      return this.value
    },
  },
  methods: {
    deleteFont(id) {
      this.$emit('delete-font', id)
    },
  },
}
</script>

<style></style>
